import type { I18nProps } from 'app.types';
import type { GetServerSidePropsResult } from 'next';

import { DeviceCategory } from 'components/pagesComponents/devices/category';

import { wrapper } from 'redux-store';
import { setUserAgent } from 'redux-store/slices/ui';

import { startSpanAndSetTransaction } from 'utils/APMService';
import getTranslate from 'utils/getTranslate';

export default DeviceCategory;

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async (context): Promise<GetServerSidePropsResult<I18nProps>> => {
      const endSpan = startSpanAndSetTransaction(context.resolvedUrl);

      await store.dispatch(setUserAgent(context.req.headers['user-agent']));

      endSpan();

      return {
        props: {
          ...(await getTranslate(context)),
        },
      };
    },
);
